import { useCallback, useEffect, useState } from "react";
import {
  campaignDataStructure,
  userData,
  selectedOptic,
  inputOnEnter,
  crmChannelOptions,
  focusElement,
  areObjectsEqual,
} from "../js/utils";
import { post } from "../js/post";
import { useCRMTemplates } from "../hooks/useCRMTemplates";
import { useCRMLists } from "../hooks/useCRMLists";
import InputData from "./InputData";
import Dropdown from "./Dropdown";
import ButtonIconH from "./ButtonIconH";
import PopupMessage from "./PopupMessage";
import ActionPopup from "./ActionPopup";
import CRMScheduledCampaignSend from "./CRMScheduledCampaignSend";
import moment from "moment";

export function CRMCampaign({ id, onSave, onClose }) {
  const [actionPopup, setActionPopup] = useState(false);
  const [actionComponent, setActionComponent] = useState(null);
  const [currentCampaign, setCurrentCampaign] = useState(campaignDataStructure);
  const [currentCampaignFixed, setCurrentCampaignFixed] = useState(
    campaignDataStructure,
  );
  const { list: templatesList, refresh: refreshTemplates } = useCRMTemplates(
    currentCampaign.canal,
  );
  const { list: listsList, refresh: refreshLists } = useCRMLists(
    currentCampaign.canal,
  );
  const [testField, setTestField] = useState("");
  const [popupQuestion, setPopupQuestion] = useState(null);

  // console.log("currentCampaign: ", currentCampaign);
  // console.log("currentCampaignFixed: ", currentCampaignFixed);

  const getCampaign = useCallback(async (id) => {
    const response = await post("support-extra/crm/ObtenerCampanaCRM.php", {
      token: userData.token,
      idCampana: id,
    });
    // console.log(
      // "OBTENIENDO CAMPAÑA: ",
      // {
        // token: userData.token,
        // idCampana: id,
      // },
      // response,
    // );
    setCurrentCampaign(response);
    setCurrentCampaignFixed(response);
  }, []);

  async function setScheduledSends(data) {
    const response = await post(
      "support-extra/crm/EnviarCampanaProgramadaCRM.php",
      {
        token: userData.token,
        idCampana: currentCampaign.idCampana,
        envios: data,
      },
    );
    // console.log(
      // "ENVÍO PROGRAMADO: ",
      // {
        // token: userData.token,
        // idCampana: currentCampaign.idCampana,
        // envios: data,
      // },
      // response,
    // );
    if (response.error === "") {
      setCurrentCampaign((prev) => ({
        ...prev,
        fechaEnvio: response.fechaEnvio,
        estado: response.estado,
      }));
      setCurrentCampaignFixed({
        ...currentCampaign,
        fechaEnvio: response.fechaEnvio,
        estado: response.estado,
      });
      onSave();
    } else {
      createPopupQuestion(
        response.error,
        async () => {
          removePopupQuestion();
        },
        null,
        "Entendido",
      );
    }
  }

  const handleOpenActionPopup = (componentType) => {
    switch (componentType) {
      case "send":
        setActionComponent({
          name: "Envío programado",
          component: (
            <CRMScheduledCampaignSend
              total={
                listsList.find((e) => e.idLista === currentCampaign.idLista)
                  ?.totalPacientes || 0
              }
              onAccept={async (data) => {
                await setScheduledSends(data);
                await getCampaign(currentCampaign.idCampana);
                setActionComponent(null);
                setActionPopup(false);
              }}
            />
          ),
        });
        break;
      default:
        setActionComponent(null);
    }
    setActionPopup(true);
  };

  function validateCampaign() {
    const requiredFields = [
      "nombre",
      "inicio",
      "fin",
      //"idPlantilla",
      "idLista",
    ];
    return requiredFields.every((field) => currentCampaign[field] !== "");
  }

  function focusFields() {
    const fieldsToFocus = [
      { field: "nombre", elementId: 5 },
      { field: "inicio", elementId: 6 },
      { field: "fin", elementId: 7 },
      { field: "idPlantilla", elementId: 9 },
      { field: "idLista", elementId: 10 },
    ];

    const emptyField = fieldsToFocus.find(
      ({ field }) => currentCampaign[field] === "",
    );

    if (emptyField) {
      focusElement(emptyField.elementId);
    }
  }

  function getPlantillaPayload() {
    const isSMS = currentCampaign.canal === "SMS";
    const selectedTemplate = templatesList.find(
      (t) => t.idPlantilla === currentCampaign.idPlantilla,
    );
    return {
      idPlantilla: currentCampaign.idPlantilla,
      mensaje: isSMS ? selectedTemplate?.prevPlantilla || "" : "",
    };
  }

  async function saveCampaign() {
    const { idPlantilla: idPlantillaToSend, mensaje: mensajeToSend } =
      getPlantillaPayload();

    const response = await post("support-extra/crm/GuardarCampanaCRM.php", {
      token: userData.token,
      idOptica: selectedOptic.id,
      idCampana: currentCampaign.idCampana,
      nombre: currentCampaign.nombre,
      inicio: currentCampaign.inicio,
      fin: currentCampaign.fin,
      canal: currentCampaign.canal,
      idPlantilla: idPlantillaToSend,
      mensaje: mensajeToSend,
      idLista: currentCampaign.idLista,
      idOptica: selectedOptic.id,
    });
    // console.log(
      // "GUARDANDO CAMPAÑA: ",
      // {
        // token: userData.token,
        // idOptica: selectedOptic.id,
        // idCampana: currentCampaign.idCampana,
        // nombre: currentCampaign.nombre,
        // inicio: currentCampaign.inicio,
        // fin: currentCampaign.fin,
        // canal: currentCampaign.canal,
        // idPlantilla: idPlantillaToSend,
        // mensaje: mensajeToSend,
        // idLista: currentCampaign.idLista,
      // },
      // response,
    // );
    setCurrentCampaign((prev) => ({
      ...prev,
      idCampana: response.idCampana,
    }));
    setCurrentCampaignFixed({
      ...currentCampaign,
      idCampana: response.idCampana,
    });
  }

  async function deleteCampaign() {
    await post("support-extra/crm/EliminarCampanaCRM.php", {
      token: userData.token,
      idCampana: currentCampaign.idCampana,
    });
    // console.log("ELIMINANDO CAMPAÑA: ", {
      // token: userData.token,
      // idCampana: currentCampaign.idCampana,
    // });
  }

  async function sendCampaignNow() {
    const response = await post("support-extra/crm/EnviarCampanaAhoraCRM.php", {
      token: userData.token,
      idCampana: currentCampaign.idCampana,
    });
    // console.log(
      // "ENVIANDO CAMPAÑA AHORA: ",
      // {
        // token: userData.token,
        // idCampana: currentCampaign.idCampana,
      // },
      // response,
    // );
    if (response.error === "") {
      setCurrentCampaign((prev) => ({
        ...prev,
        estado: response.estado,
        fechaEnvio: response.fechaEnvio,
      }));
      setCurrentCampaignFixed({
        ...currentCampaign,
        estado: response.estado,
        fechaEnvio: response.fechaEnvio,
      });
      onSave();
    } else {
      createPopupQuestion(
        response.error,
        async () => {
          removePopupQuestion();
        },
        null,
        "Entendido",
      );
    }
  }

  async function sendTest() {
    const { idPlantilla: idPlantillaToSend, mensaje: mensajeToSend } =
      getPlantillaPayload();

    const response = await post(
      "support-extra/crm/EnviarCampanaPruebaCRM.php",
      {
        token: userData.token,
        input: testField,
        canal: currentCampaign.canal,
        idPlantilla: idPlantillaToSend,
        mensaje: mensajeToSend,
        idOptica: selectedOptic.id,
      },
    );
    // console.log(
      // "ENVIANDO PRUEBA: ",
      // {
        // token: userData.token,
        // input: testField,
        // canal: currentCampaign.canal,
        // idPlantilla: idPlantillaToSend,
        // mensaje: mensajeToSend,
        // idOptica: selectedOptic.id,
      // },
      // response,
    // );
    if (response.error !== "") {
      createPopupQuestion(
        response.error,
        async () => {
          removePopupQuestion();
        },
        null,
        "Entendido",
      );
    } else {
      createPopupQuestion(
        "Prueba enviada correctamente.",
        async () => {
          removePopupQuestion();
        },
        null,
        "Entendido",
      );
    }
  }

  const createPopupQuestion = (
    text,
    onClickAccept,
    onClickCancel,
    textAccept,
    textCancel,
  ) => {
    setPopupQuestion({
      text,
      onClickCancel,
      onClickAccept,
      textAccept,
      textCancel,
    });
  };

  const removePopupQuestion = () => {
    setPopupQuestion(null);
  };

  const isDisabled = currentCampaign.estado !== "Borrador";

  useEffect(() => {
    focusElement(5);
    if (id !== -1) getCampaign(id);
  }, [id, getCampaign]);

  useEffect(() => {
    async function updateTemplatesForCanal() {
      const [templates, lists] = await Promise.all([
        refreshTemplates(),
        refreshLists(),
      ]);
      const firstTemplate = templates?.[0];
      const firstList = lists?.[0];
      setCurrentCampaign((prev) => {
        if (prev.estado !== "Borrador") return prev;
        return {
          ...prev,
          idPlantilla:
            prev.idPlantilla !== ""
              ? prev.idPlantilla
              : firstTemplate
                ? firstTemplate.idPlantilla
                : "",
          nombrePlantilla:
            prev.idPlantilla !== ""
              ? prev.nombrePlantilla
              : firstTemplate
                ? firstTemplate.nombrePlantilla
                : "",
          idLista:
            prev.idLista !== ""
              ? prev.idLista
              : firstList
                ? firstList.idLista
                : "",
          nombreLista:
            prev.idLista !== ""
              ? prev.nombreLista
              : firstList
                ? firstList.nombreLista
                : "",
        };
      });
    }
    updateTemplatesForCanal();
  }, [currentCampaign.canal]);

  return (
    <div className="popup-container">
      <div className="ap-container popup-screen">
        <div className="popup-screen-header">
          <span className="popup-screen-header-title">Ficha de campaña</span>
          <button
            className="popup-action-icon close-icon"
            onClick={() => {
              if (!areObjectsEqual(currentCampaign, currentCampaignFixed)) {
                createPopupQuestion(
                  "Existen cambios sin guardar. ¿Desea salir de la ficha de campaña?",
                  async () => {
                    removePopupQuestion();
                    onClose();
                  },
                  () => {
                    removePopupQuestion();
                  },
                  "Sí",
                  "No",
                );
              } else onClose();
            }}
          >
            <img src="/images/close-white.svg" loading="lazy" alt="Icon"></img>
          </button>
        </div>
        <div
          className="tab-content ap-content"
          style={{ overflow: "unset", backgroundColor: "#f9f9f9" }}
        >
          <div
            className="container-panel"
            style={{ display: "flex", flexDirection: "column", gap: 10 }}
          >
            <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
              <div
                style={{
                  display: "flex",
                  gap: 20,
                  alignItems: "flex-start",
                }}
              >
                {popupQuestion && (
                  <PopupMessage
                    text={popupQuestion.text}
                    onClickCancel={popupQuestion.onClickCancel}
                    onClickAccept={popupQuestion.onClickAccept}
                    textAccept={popupQuestion.textAccept}
                    textCancel={popupQuestion.textCancel}
                  ></PopupMessage>
                )}
                {actionPopup && (
                  <ActionPopup
                    name={actionComponent.name}
                    children={actionComponent.component}
                    overflowStyle={false}
                    onClose={async () => {
                      setActionPopup(false);
                      setActionComponent(null);
                    }}
                  ></ActionPopup>
                )}
                <div className="opt-table-content grid-5" id="campaign-grid">
                  <div className="cell cell-label cell-start-content">
                    Estado
                  </div>
                  <div className="cell combined-cells-4 cell-start-content">
                    {currentCampaign.estado}
                  </div>
                  <div className="cell cell-label cell-start-content">
                    Nombre
                  </div>
                  <div className="cell combined-cells-4">
                    <InputData
                      tabIndex={5}
                      inactive={isDisabled}
                      type="type-alphanum-ext"
                      size={0}
                      input={currentCampaign.nombre}
                      onChange={(e) => {
                        setCurrentCampaign((prev) => ({
                          ...prev,
                          nombre: e,
                        }));
                      }}
                    ></InputData>
                  </div>
                  <div className="cell cell-label cell-start-content">
                    Inicio
                  </div>
                  <div className="cell">
                    <input
                      type="date"
                      max="9999-12-31"
                      tabIndex={6}
                      disabled={isDisabled}
                      className="input-field input-cell"
                      value={currentCampaign.inicio}
                      onChange={(e) => {
                        setCurrentCampaign((prev) => ({
                          ...prev,
                          inicio: e.target.value,
                        }));
                      }}
                      onKeyUp={(e) => inputOnEnter(e)}
                    ></input>
                  </div>
                  <div className="cell"></div>
                  <div className="cell cell-label cell-start-content">Fin</div>
                  <div className="cell">
                    <input
                      type="date"
                      max="9999-12-31"
                      tabIndex={7}
                      disabled={isDisabled}
                      className="input-field input-cell"
                      value={currentCampaign.fin}
                      onChange={(e) => {
                        setCurrentCampaign((prev) => ({
                          ...prev,
                          fin: e.target.value,
                        }));
                      }}
                      onKeyUp={(e) => inputOnEnter(e)}
                    ></input>
                  </div>
                  <div className="cell cell-label cell-start-content">
                    Canal
                  </div>
                  <div className="cell combined-cells-4">
                    <Dropdown
                      tabIndex={8}
                      optionList={crmChannelOptions}
                      size={0}
                      disabled={isDisabled}
                      op={currentCampaign.canal}
                      mandatory={true}
                      onChange={(e) => {
                        if (e.id === currentCampaign.canal) return;
                        setCurrentCampaign((prev) => ({
                          ...prev,
                          canal: e.id,
                          idPlantilla: "",
                          nombrePlantilla: "",
                          idLista: "",
                          nombreLista: "",
                        }));
                      }}
                    ></Dropdown>
                  </div>
                  <div className="cell cell-label cell-start-content">
                    Plantilla
                  </div>
                  <div className="cell combined-cells-4">
                    {currentCampaign.canal === "SMS" &&
                    currentCampaign.estado !== "Borrador" ? (
                      <InputData
                        tabIndex={9}
                        inactive={true}
                        type="type-alphanum-ext"
                        size={0}
                        input={currentCampaign.nombrePlantilla}
                        onChange={() => {}}
                      ></InputData>
                    ) : (
                      <Dropdown
                        tabIndex={9}
                        optionList={templatesList.map((e) => ({
                          id: e.idPlantilla,
                          text: e.nombrePlantilla,
                        }))}
                        size={0}
                        disabled={isDisabled || currentCampaign.canal === ""}
                        op={currentCampaign.idPlantilla}
                        mandatory={true}
                        onChange={(e) => {
                          if (e.id === currentCampaign.idPlantilla) return;
                          if (
                            !templatesList.some((t) => t.idPlantilla === e.id)
                          )
                            return;
                          setCurrentCampaign((prev) => ({
                            ...prev,
                            idPlantilla: e.id,
                            nombrePlantilla: e.text,
                          }));
                        }}
                      ></Dropdown>
                    )}
                  </div>
                  <div className="cell cell-label cell-start-content">
                    Lista
                  </div>
                  <div className="cell combined-cells-4">
                    {currentCampaign.estado === "Enviado" ? (
                      <InputData
                        tabIndex={10}
                        inactive={true}
                        type="type-alphanum-ext"
                        size={0}
                        input={currentCampaign.nombreLista}
                        onChange={() => {}}
                      ></InputData>
                    ) : (
                      <Dropdown
                        tabIndex={10}
                        optionList={listsList.map((e) => ({
                          id: e.idLista,
                          text:
                            e.nombreLista + ` (Pacientes: ${e.totalPacientes})`,
                        }))}
                        size={0}
                        disabled={isDisabled || currentCampaign.canal === ""}
                        op={currentCampaign.idLista}
                        mandatory={true}
                        onChange={(e) => {
                          // console.log("LISTA SELECT: ", e);
                          if (!listsList.some((l) => l.idLista === e.id))
                            return;
                          setCurrentCampaign((prev) => ({
                            ...prev,
                            idLista: e.id,
                            nombreLista: e.text.replace(
                              / \(Pacientes:.*\)$/,
                              "",
                            ),
                          }));
                        }}
                      ></Dropdown>
                    )}
                  </div>
                  {currentCampaign.fechaEnvio !== "" && (
                    <>
                      <div className="cell cell-label cell-start-content">
                        Fecha envío
                      </div>
                      <div className="cell cell-start-content combined-cells-4">
                        {moment(currentCampaign.fechaEnvio).format(
                          "DD/MM/YYYY HH:mm:ss",
                        )}
                      </div>
                    </>
                  )}
                  {!isDisabled && (
                    <div className="cell combined-cells-5">
                      <ButtonIconH
                        text="Enviar ahora"
                        small={true}
                        disabled={
                          currentCampaign.idCampana === -1 ||
                          !validateCampaign()
                        }
                        onClick={async () => {
                          const patientsExist = listsList.find(
                            (e) => e.idLista === currentCampaign.idLista,
                          ).totalPacientes;
                          if (patientsExist === 0) {
                            createPopupQuestion(
                              "La lista seleccionada no tiene pacientes. Seleccione una lista con pacientes.",
                              async () => {
                                removePopupQuestion();
                              },
                              null,
                              "Entendido",
                            );
                          } else {
                            createPopupQuestion(
                              "Si continúa con el envío de la campaña, esta no se podrá editar después. ¿Desea continuar?",
                              async () => {
                                await saveCampaign();
                                removePopupQuestion();
                                await sendCampaignNow();
                              },
                              () => {
                                removePopupQuestion();
                              },
                              "Sí",
                              "No",
                            );
                          }
                        }}
                      ></ButtonIconH>
                      <ButtonIconH
                        text="Programar envío"
                        small={true}
                        disabled={
                          currentCampaign.idCampana === -1 ||
                          !validateCampaign()
                        }
                        onClick={async () => {
                          const patientsExist = listsList.find(
                            (e) => e.idLista === currentCampaign.idLista,
                          ).totalPacientes;
                          if (patientsExist === 0) {
                            createPopupQuestion(
                              "La lista seleccionada no tiene pacientes. Seleccione una lista con pacientes.",
                              async () => {
                                removePopupQuestion();
                              },
                              null,
                              "Entendido",
                            );
                          } else {
                            createPopupQuestion(
                              "Si continúa con el envío programado de la campaña, esta no se podrá editar después. ¿Desea continuar?",
                              async () => {
                                await saveCampaign();
                                removePopupQuestion();
                                handleOpenActionPopup("send");
                              },
                              () => {
                                removePopupQuestion();
                              },
                              "Sí",
                              "No",
                            );
                          }
                        }}
                      ></ButtonIconH>
                    </div>
                  )}
                  {currentCampaign.enviosProgramados.length > 0 && (
                    <div className="cell combined-cells-5 cell-start-content">
                      <div
                        className="dashboard-section"
                        style={{
                          fontWeight: 500,
                          gap: 0,
                          backgroundColor: "#ffe7cb",
                        }}
                      >
                        <span style={{ marginBottom: 5 }}>
                          Envíos programados (
                          {currentCampaign.enviosProgramados.length}
                          ):
                        </span>
                        {currentCampaign.enviosProgramados.map((e, i) => (
                          <div key={i}>
                            {"- Día " +
                              moment(e.fechaHora).format(
                                "DD/MM/YYYY HH:mm:ss",
                              ) +
                              ` (${e.numEnvios} ${currentCampaign.canal})`}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", gap: 10 }}
              >
                <div className="template-viewer-container">
                  <div style={{ whiteSpace: "pre-wrap" }}>
                    {templatesList.find(
                      (t) => t.idPlantilla === currentCampaign.idPlantilla,
                    )?.prevPlantilla || "No se puede previsualizar plantilla."}
                  </div>
                </div>
                <div
                  className="opt-table-content grid-3"
                  id="campaign-test-grid"
                >
                  <div className="cell cell-start-content cell-label">
                    {currentCampaign.canal === "Email" ? "Email" : "Móvil"}
                  </div>
                  <div className="cell">
                    <InputData
                      tabIndex={11}
                      type={`${
                        currentCampaign.canal === "Email"
                          ? "type-email"
                          : "type-phone"
                      }`}
                      size={0}
                      inactive={isDisabled}
                      input={testField}
                      onChange={(e) => {
                        setTestField(e);
                      }}
                    ></InputData>
                  </div>
                  <div className="cell">
                    <ButtonIconH
                      text="Enviar prueba"
                      small={true}
                      disabled={
                        isDisabled ||
                        currentCampaign.canal === "" ||
                        currentCampaign.idPlantilla === ""
                      }
                      onClick={async () => {
                        if (testField !== "") {
                          await sendTest();
                        }
                      }}
                    ></ButtonIconH>
                  </div>
                </div>
              </div>
            </div>
            {currentCampaign.estado === "Borrador" && (
              <div
                className="popup-buttons"
                style={{ margin: "10px 25% 0 25%" }}
              >
                <ButtonIconH
                  text="Guardar"
                  onClick={async () => {
                    if (!validateCampaign()) {
                      createPopupQuestion(
                        "Por favor, rellene todos los campos de la ficha de campaña.",
                        async () => {
                          removePopupQuestion();
                          focusFields();
                        },
                        null,
                        "Entendido",
                      );
                    } else {
                      await saveCampaign();
                      onSave();
                      createPopupQuestion(
                        "Ficha guardada con éxito.",
                        async () => {
                          removePopupQuestion();
                        },
                        null,
                        "Entendido",
                      );
                    }
                  }}
                ></ButtonIconH>
                <ButtonIconH
                  text="Eliminar"
                  onClick={async () => {
                    createPopupQuestion(
                      "¿Desea eliminar la campaña?",
                      async () => {
                        removePopupQuestion();
                        await deleteCampaign();
                        onSave();
                        onClose();
                      },
                      () => {
                        removePopupQuestion();
                      },
                      "Sí",
                      "No",
                    );
                  }}
                  disabled={currentCampaign.idCampana === -1}
                ></ButtonIconH>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
